import React, { useState } from 'react'
import Header from '../../comps/Header';
import Footer from '../../comps/Footer';
import Select from "react-select";
import { add_addresses } from '../../api/Product';
import Country_State_Data from '../country_state_data/Country_State_Data';
import { useNavigate } from 'react-router-dom';

const Billing_Address = () => {
   const navigate = useNavigate();
    const get_user_data = localStorage.getItem("user");
    const parsedUserData = JSON.parse(get_user_data); // Parse JSON string
    console.log("User Email:", parsedUserData?.email);

    // 🌍 Convert countries into react-select format
    const countryOptions = Object.entries(Country_State_Data).map(([code, details]) => ({
        value: code,
        label: details.name,
    }));

    const [formData, setFormData] = useState({
        type: "billing",
        fullName: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        phone: '',
        email: parsedUserData?.email || '', // Initialize email from localStorage
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Handle Country Selection
    const handleCountryChange = (selectedOption) => {
        setFormData({ ...formData, country: selectedOption, state: null });
    };

    // Handle State Selection
    const handleStateChange = (selectedOption) => {
        setFormData({ ...formData, state: selectedOption });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const token = localStorage.getItem("token");

            const headers = {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            };

            // Convert state & country to string before sending
            const payload = {
                ...formData,
                state: formData.state?.value || "",
                country: formData.country?.value || "",
            };

            const response = await add_addresses(payload, headers);
            console.log("Response:", response);
            navigate("/my-account")
            setFormData({
                fullName: '',
                address: '',
                city: '',
                state: '',
                zip: '',
                country: '',
                phone: '',
            });

        } catch (error) {
            console.error("Error submitting form", error);
        }
    };


    return (
        <>
            {/*  */}
            <Header />
            <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
                <div className="bg-white shadow-md rounded-lg w-full max-w-lg">
                    <div className="px-6 py-4 border-b">
                        <h2 className="text-2xl font-bold text-gray-800">Billing Address</h2>
                    </div>
                    <form onSubmit={handleSubmit} className="px-6 py-4">

                        <div className="mb-4">
                            <label htmlFor="email" className="block text-gray-700 mb-2">
                                Email address
                            </label>
                            <input type="text" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter your email address" required className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300" />
                        </div>
                        {/* Full Name */}
                        <div className="mb-4">
                            <label htmlFor="fullName" className="block text-gray-700 mb-2">
                                Full Name
                            </label>
                            <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} placeholder="Enter your full name" required className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300" />
                        </div>

                        {/* Address */}
                        <div className="mb-4">
                            <label htmlFor="address" className="block text-gray-700 mb-2">
                                Address
                            </label>
                            <input type="text" id="address" name="address" value={formData.address} onChange={handleChange} placeholder="Enter your address" required className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300" />
                        </div>

                        {/* City and State */}
                        <div className="mb-4 grid grid-cols-1 md:grid-cols-1 gap-4">
                            <div className="">
                                <label className="block text-gray-700 mb-2">Country *</label>
                                <Select className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring focus:border-blue-300"
                                    options={countryOptions} value={formData.country}
                                    onChange={handleCountryChange}
                                    styles={{
                                        control: (provided) => ({ ...provided, border: "none", boxShadow: "none", }),
                                        dropdownIndicator: (provided) => ({ ...provided, padding: "4px", }),
                                    }}
                                    placeholder="Select a country..." />
                            </div>

                            {/* State Dropdown (Only Appears After Selecting Country) */}
                            {formData.country && (
                                <div className="mb-4">
                                    <label className="block text-gray-700 mb-2">State *</label>
                                    <Select className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring focus:border-blue-300"
                                        options={Country_State_Data[formData.country.value]?.states.map((state) => ({ value: state, label: state }))}
                                        value={formData.state}
                                        onChange={handleStateChange}
                                        styles={{
                                            control: (provided) => ({ ...provided, border: "none", boxShadow: "none", }),
                                            dropdownIndicator: (provided) => ({ ...provided, padding: "4px", }),
                                        }}
                                        placeholder="Select a state..."
                                    />
                                </div>
                            )}
                            {/* <div>
                                <label htmlFor="state" className="block text-gray-700 mb-2">
                                    State
                                </label>
                                <input
                                    type="text"
                                    id="state"
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                    placeholder="State"
                                    required
                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300"
                                />
                            </div> */}
                        </div>

                        {/* ZIP Code and Country */}
                        <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label htmlFor="zip" className="block text-gray-700 mb-2">
                                    ZIP Code
                                </label>
                                <input
                                    type="text"
                                    id="zip"
                                    name="zip"
                                    value={formData.zip}
                                    onChange={handleChange}
                                    placeholder="ZIP Code"
                                    required
                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300"
                                />
                            </div>
                            <div>
                                <label htmlFor="city" className="block text-gray-700 mb-2">
                                    City
                                </label>
                                <input
                                    type="text"
                                    id="city"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                    placeholder="City"
                                    required
                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300"
                                />
                            </div>
                        </div>

                        {/* Phone Number */}
                        <div className="mb-4">
                            <label htmlFor="phone" className="block text-gray-700 mb-2">
                                Phone Number
                            </label>
                            <input
                                type="number"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="(123) 456-7890"
                                required
                                className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300"
                            />
                        </div>

                        {/* Save Button */}
                        <div className="flex justify-end">
                            <button
                                type="submit"
                                className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700"
                            >
                                Save Address
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            {/*  */}
            <Footer />
        </>
    )
}

export default Billing_Address
